import { Schema } from 'effect';
import { SiteId } from './common.js';
/** DTO schemas for the /media group. See http/payment.ts for conventions. */
export const UploadBody = Schema.Struct({
    siteId: SiteId,
    filename: Schema.String,
    fileData: Schema.String
});
export const ListQuery = Schema.Struct({
    siteId: Schema.optional(SiteId),
    log: Schema.optional(Schema.String)
});
export const DeleteBody = Schema.Struct({
    siteId: SiteId,
    fileId: Schema.String
});
/** Media docs are returned as `toMediaDoc` shapes them (not decoded client-side). */
export const MediaResponse = Schema.Any;
export const MediaListResponse = Schema.mutable(Schema.Array(Schema.Any));
export const DeleteResponse = Schema.Struct({ success: Schema.Boolean });
//# sourceMappingURL=media.js.map